// extracted by mini-css-extract-plugin
export default {"main":"styles_main__InMB+","header":"styles_header__gqREn","text":"styles_text__zOZML"};